import { render, staticRenderFns } from "./IdleModal.component.html?vue&type=template&id=38155425&"
import script from "./IdleModal.component.ts?vue&type=script&lang=ts&"
export * from "./IdleModal.component.ts?vue&type=script&lang=ts&"
import style0 from "./IdleModal.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports